
import axios from 'axios'

export default {
  namespaced: true,
  state: {
    orderHistory: {},
    recentOrderHistory: {}
  },
  mutations: {
    setOrderHistory (state, payload) {
      state.orderHistory = payload
    },
    setRecentOrderHistory (state, payload) {
      state.recentOrderHistory = payload
    },
    setRepeatOrderPlan (state, payload) {
      state.repeatOrderPlan = payload
    }
  },
  actions: {
    getOrderHistory ({ commit, state }) {
      return axios.get('/Orders/GetCustomerOrders').then((response) => {
        commit('setOrderHistory', response.data)
      })
    },
    getRecentOrderHistory ({ commit, state }) {
      return axios.get('/Orders/GetRecentlyOrderProducts').then((response) => {
        commit('setRecentOrderHistory', response.data.Products)
      })
    },
    getRepeatOrderPlan ({ commit, state }) {
      return axios.get('/Orders/GetCustomerPlannedOrders').then((response) => {
        commit('setRepeatOrderPlan', response.data)
      })
    }
  },
  getters: {
    getOrderHistory: state => {
      return state.orderHistory
    },
    getRecentOrderHistory: state => {
      return state.recentOrderHistory
    },
    getRepeatOrderPlan: state => {
      return state.repeatOrderPlan
    }
  }
}
